import { useQuery } from "@tanstack/react-query";

import {
  getPartnerDetailSummaryService,
  getPartnerHistoryService,
  getPartnerMonthlyService,
  getPartnerReferralsService,
} from "./service";

export function usePartnerReferralsQuery(id?: number | string) {
  return useQuery({
    queryKey: ["v1/partner_admin", String(id), "referrals"],
    queryFn: async () => getPartnerReferralsService(id as number | string),
    enabled: Boolean(id),
  });
}

export function usePartnerDetailSummaryQuery(id?: number | string) {
  return useQuery({
    queryKey: ["v1/partner_admin", String(id), "summary"],
    queryFn: async () => getPartnerDetailSummaryService(id as number | string),
    enabled: Boolean(id),
  });
}

export function usePartnerMonthlyQuery(id?: number | string) {
  return useQuery({
    queryKey: ["v1/partner_admin", String(id), "monthly"],
    queryFn: async () => getPartnerMonthlyService(id as number | string),
    enabled: Boolean(id),
  });
}

export function usePartnerHistoryQuery(id?: number | string) {
  return useQuery({
    queryKey: ["v1/partner_admin", String(id), "history"],
    queryFn: async () => getPartnerHistoryService(id as number | string),
    enabled: Boolean(id),
  });
}
